const $JQ = jQuery;
(function($){
  $(function(){
    var $tabSingle = $('.zn-tab');

    if ( $tabSingle.length ) {
      var tabBreak = 1024,
          opened = 'zn-active';

      //Wrap Tab Groups
      $('.zn-tab:first-of-type, :not(.zn-tab) + .zn-tab').each(function(){
        $(this).nextUntil($('*').not($tabSingle)).addBack().wrapAll('<div class="zn-tabs-group"><div class="zn-tab-stage" /></div>');
      });

      var $tabs = $('.zn-tabs-group');
      //Tabs Foundation 
      $tabs.each(function(idx,itm){
        var tabId = 'zn-tabs-' + idx,
            $tab = $(itm),
            resetTabs = function(){
              $tab.find('.zn-tab-stage').children('.zn-tab').removeClass(opened).removeAttr('style').children('.zn-content').removeAttr('style');
              $tab.find('ul').children('li').removeClass(opened).removeAttr('style');
              $tab.find('.zn-tab-stage').find('.zn-title-button').attr('aria-expanded', 'false');
            }

        $tab.attr('id', tabId).prepend('<ul class="zn-tab-list" role="tablist" />');

        var $tabStage = $tab.children('.zn-tab-stage'),
            $tabList = $tab.children('.zn-tab-list');

        $tabStage.children('.zn-tab').each(function(idx2, itm2) {
          var secId = tabId + "-section-" + idx2,
              $sec = $(itm2);

          $sec.children('.zn-content').attr('id', secId);
          $sec.children('.zn-title').wrapInner('<div class="zn-title-button" role="button" tabindex="0" aria-expanded="false" aria-controls="'+secId+'"></div>').clone().appendTo($tabList).wrap('<li />').children('.zn-title-button').attr('role', 'tab').attr('aria-selected', 'false').attr('id', secId+'-tab').attr('tabindex', '-1').removeAttr('aria-expanded'); 
        });

        var $expBtn = $tabStage.find('.zn-title-button'),
            $tabBtn = $tabList.find('.zn-title-button'),
            $tabContent = $tab.find('.zn-content');

        var tabFunc = [
              {
                min: 0,
                max: (tabBreak -1),
                enter: function(){
                  $tabContent.attr('role', 'region');
    
    
                  $expBtn.on('click.tabexp', function(e){
                    var $this = $(this),
                        $thisSec = $this.closest('.zn-tab'),
                        $panel = $('#'+$this.attr('aria-controls'));
    
                    $thisSec.toggleClass(opened);
                    $panel.slideToggle('fast');
    
                    if ($thisSec.hasClass(opened)) {
                      $this.attr('aria-expanded', 'true');
                    } else {
                      $this.attr('aria-expanded', 'false');
                    }
                  });
    
                  $expBtn.on('keydown.tabexp', function(e){
                    var keyCode = e.which,
                        $this = $(this);
                    if ((keyCode === 13) || (keyCode === 32)) {
                      //if enter or space hit
                      e.preventDefault();
                      $this.click();
                    } else if (keyCode === 40) {
                      //if arrow down hit
                      e.preventDefault();
                      var $li = $this.closest('.zn-tab');
                      if ($li.is('.zn-tab:last-child')) {
                        $li.parent('.zn-tab-stage').children('.zn-tab:first-child').children('.zn-title').children('.zn-title-button').focus();
                      } else {
                        $li.next('.zn-tab').children('.zn-title').children('.zn-title-button').focus();
                      }
                    } else if (keyCode === 38) {
                      //if arrow up hit
                      e.preventDefault();
                      var $li = $this.closest('.zn-tab');
                      if ($li.is('.zn-tab:first-child')) {
                        $li.parent('.zn-tab-stage').children('.zn-tab:last-child').children('.zn-title').children('.zn-title-button').focus();
                      } else {
                        $li.prev('.zn-tab').children('.zn-title').children('.zn-title-button').focus();
                      }
                    }
                  });
                },
                exit: function(){
                  $expBtn.off('click.tabexp');
                  $expBtn.off('keydown.tabexp');
                  resetTabs();
                }
              },
              {
                min: tabBreak,
                max: 99999,
                enter: function(){
                  $tabBtn.each(function(){
                    var $this = $(this),
                        thisId = $(this).attr('id');
    
                    $('#'+ $this.attr('aria-controls')).attr('aria-labelledby', thisId).attr('role', 'tabpanel').attr('tabindex', '0');
                  });
    
    
                  $tabBtn.on('click.tabfull', function(e){
                    var $this = $(this),
                        $thisSec = $this.closest('li'),
                        $panel = $('#'+$this.attr('aria-controls')),
                        $panelSec = $panel.closest('.zn-tab');

                    if( !$thisSec.hasClass(opened) ) {
                      $tabBtn.attr('aria-selected', 'false').attr('tabindex', '-1').closest('li').removeClass(opened);
                      $tabContent.slideUp('fast').closest('.zn-tab').removeClass(opened);

                      $this.attr('aria-selected', 'true').attr('tabindex', '0');
                      $thisSec.addClass(opened);
                      $panelSec.addClass(opened);
                      $panel.slideDown('fast');
                    }
                  });
    
                  $tabBtn.on('keydown.tabfull', function(e){
                    var keyCode = e.which,
                        $this = $(this);
                    if (keyCode === 13 || keyCode === 32) {
                      //if enter or space hit
                      e.preventDefault();
                      $this.click();
                    } else if (keyCode === 39 || keyCode === 40) {
                      //if arrow right hit
                      e.preventDefault();
                      var $li = $this.closest('li');
                      if ($li.is('li:last-child')) {
                        $li.parent('ul').children('li:first-child').children('.zn-title').children('.zn-title-button').focus();
                      } else {
                        $li.next('li').children('.zn-title').children('.zn-title-button').focus();
                      }
                    } else if (keyCode === 37 || keyCode === 38) {
                      //if arrow left hit
                      e.preventDefault();
                      var $li = $this.closest('li');
                      if ($li.is('li:first-child')) {
                        $li.parent('ul').children('li:last-child').children('.zn-title').children('.zn-title-button').focus();
                      } else {
                        $li.prev('li').children('.zn-title').children('.zn-title-button').focus();
                      }
                    }
                  });
    
                  $tabList.find('li:first-child').find('.zn-title-button').trigger('click');
    
                },
                exit: function(){
                  $tabBtn.off('click.tabfull');
                  $tabBtn.off('keydown.tabfull');
                  $tabContent.removeAttr('aria-labelledby').removeAttr('tabindex');
                  resetTabs();
                }
              }
            ];
    
        breakdance(tabFunc);

      });
    };

  });
})($JQ);